<div class="user-list-container">
  <h2>Listado de Usuarios</h2>
  <div class="controls-container">
    <div class="search-bar">
      <input
        type="text"
        placeholder="Buscar por nombre o email..."
        [(ngModel)]="searchTerm"
        (input)="applyFilters()"
      />
    </div>
    <div class="filters">
      <button [class.active]="activeFilter === 'todos'" (click)="setFilter('todos')">Todos</button>
      <button [class.active]="activeFilter === 'activo'" (click)="setFilter('activo')">Activos</button>
      <button [class.active]="activeFilter === 'no-asignado'" (click)="setFilter('no-asignado')">No Asignados</button>
    </div>
  </div>

  <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th>Nombre</th>
        <th>Email</th>
        <th>Estado</th>
      </tr>
      </thead>
      <tbody>
        @for (user of filteredUsers; track user.idHash) {
          <tr (click)="selectUser(user)" [class.selected]="user.idHash === selectedUserId">
            <td>{{ user.name }} {{ user.firstSurname }}</td>
            <td>{{ user.email || user.loginName }}</td>
            <td>
              <span [ngClass]="getUserStatus(user) === 'activo' ? 'status-active' : 'status-inactive'">
                {{ getUserStatus(user) === 'activo' ? 'Activo' : 'No Asignado' }}
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
